import React from 'react'
import {Flex, SVGButton} from '/app/src/component';

const containerStyle = {
    width: '700px',
    height: '100%',
    margin: '0 auto'
}

const bodyTextStyle = {
    fontSize: '25px',
    color: 'Black_M'
}

const buttonContainer = {
    vAlignContent: 'bottom',
    hAlignContent: 'center',
    marginBottom: '25px'
}

const featuresStyle = {
    marginTop: '30px'
}

const imgStyle = {
    alignSelf: 'center',
    maxWidth: '100%'
}

const contentContainer = {
    marginTop: '50px'
}

const WelcomeScreen = ({headerText, bodyText, features, planImgSrc, color, onClose}) => {
    const buttonStyle = {
        backgroundColor: color,
        color: 'white',
        height: '50px',
        width: '130px',
        borderColor: color
    }

    const headerStyle = {
        fontSize: '33px',
        color: color,
        padding: '30px 0px',
        hAlignContent: 'center',
        width: '100%'
    }

    return (
        <Flex {...containerStyle} column>
            <Flex {...headerStyle}>
                {headerText}
            </Flex>
            <Flex {...contentContainer}>
                <Flex column basis='450px'>
                    <Flex {...bodyTextStyle}>
                        {bodyText}
                    </Flex>
                    <Flex {...featuresStyle}>
                        {features}
                    </Flex>
                </Flex>
                <Flex>
                    <img style={imgStyle} src={planImgSrc} alt=''/>
                </Flex>
            </Flex>
            <Flex {...buttonContainer} grow >
                <SVGButton onClick={onClose} text='Ok!' {...buttonStyle}/>
            </Flex>
        </Flex>
    )
}

export default WelcomeScreen;



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/WelcomeScreen.js